import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { Command, GetCommandsProps } from "common/app/command-palette/types";
import { getAdminMenuEntries } from "x/layout/navigation/admin-menu";

export class AccountSettingsProvider extends BaseCommandProvider {
  getCommands({ context }: GetCommandsProps): Command[] {
    return getAdminMenuEntries(context).map((entry) => ({
      id: `account-settings:${entry.link}`,
      label: entry.label,
      icon: entry.icon,
      link: entry.link,
      category: "account-settings",
    }));
  }
}
